import * as React from 'react';

export interface ILangInterface {
  lang: string;
  name: string;
  messages: any;
  key?: any;
}

const Context = React.createContext<ILangInterface | null>(null);
const { Provider: LangProvider, Consumer: LangConsumer } = Context

export {
  LangProvider,
  LangConsumer
}


// WEBPACK FOOTER //
// ./src/locales/provider.tsx